import React from "react";
import { Flex, Box, useColorMode } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useMediaQ from "@root/hooks/useMediaQ";

export const CommonFooter: React.FC = () => {
  const { t } = useTranslation("common");
  const { colorMode } = useColorMode();
  const { sm } = useMediaQ();

  const footerItems: any = [
    {
      label: `${t("translate.copyRight")} ${new Date().getFullYear()}`,
      link: "",
    },
    // {
    //   label: <ContactModal children={t("sideMenu.contact")} />,
    //   link: pathname,
    // },
    // {
    //   label: t("sideMenu.privacy"),
    //   link: ROUTE_NAMES.PRIVACY_POLICY,
    // },
    // {
    //   label: t("sideMenu.termsCondition"),
    //   link: ROUTE_NAMES.TERMS_CONDITION,
    // },
  ];

  return (
    <Box>
      <Flex
        as="footer"
        justify="space-between"
        align="center"
        px={{ base: "24px", md: "40px", lg: "77px" }}
        py={{ base: "24px", md: "20px" }}
        bg={"transparent"}
        width="100%"
        borderTop="1px solid"
        _dark={{ borderTopColor: "theme.gray.200" }}
        borderTopColor={"theme.gray.100"}
      >
        {sm && (
          <Box
            color={colorMode === "dark" ? "white" : "gray.500"}
            fontSize={"14px"}
            fontWeight={"400"}
          >
            {footerItems[0]?.label}
          </Box>
        )}
        <Flex flexWrap={"wrap"} gap="20px">
          {footerItems?.slice(1).map((item: any, index: number) => (
            <Box
              key={`${item.label}-${index}`}
              as={Link}
              to={item.link}
              color={colorMode === "dark" ? "white" : "gray.500"}
              fontSize={"12px"}
              fontWeight={"700"}
            >
              {item?.label}
            </Box>
          ))}
        </Flex>
      </Flex>
      {!sm && (
        <Box
          px={"24px"}
          pb={"16px"}
          color={colorMode === "dark" ? "white" : "gray.500"}
        >
          {footerItems[0]?.label}
        </Box>
      )}
    </Box>
  );
};
